import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { verifyRecipientTokenApi } from './verifyRecipientToken.api'
import initialState from './verifyRecipientToken.initialState'
import { VerifyRecipientTokenRequest } from './verifyRecipientToken.types'

export const verifyRecipientToken = createAsyncThunk(
  'recipient/verifyRecipientToken',
  async (request: VerifyRecipientTokenRequest) => {
    return await verifyRecipientTokenApi(request)
  }
)

const verifyRecipientTokenSlice = createSlice({
  name: 'verifyRecipientToken',
  initialState,
  reducers: {
    resetVerifyRecipientToken: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyRecipientToken.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(verifyRecipientToken.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(verifyRecipientToken.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to verify token'
      })
  }
})

export const { resetVerifyRecipientToken } = verifyRecipientTokenSlice.actions
export default verifyRecipientTokenSlice.reducer
